import React, { PropsWithChildren, useState } from 'react';
import { AccordionSummary, AccordionDetails } from '@mui/material';
import Arrow from '../../assets/img/arrowFilter.svg';
import GreenArrow from '../../assets/img/greenArrow.svg';
import { AccordionStyled } from './styled';
import theme from '../../constants/theme';

type Props = PropsWithChildren<{
  header: JSX.Element;
}>;

export const Accordion = ({ header, children }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleAccordionChange = () => {
    setIsExpanded((prevState) => !prevState);
  };
  return (
    <AccordionStyled
      expanded={isExpanded}
      onChange={handleAccordionChange}
      sx={{
        margin: '0 16px !important',
        '.MuiAccordionSummary-content': {
          width: 'calc(100% - 32px)',
        },
      }}
    >
      <AccordionSummary
        expandIcon={
          <img
            src={isExpanded ? GreenArrow : Arrow}
            alt="Arrow"
            style={{ rotate: '90deg', width: '20px' }}
          />
        }
        sx={{
          margin: '0 16px !important',
          h6: {
            color: isExpanded
              ? theme.palette.text.primary
              : theme.palette.text.secondary,
            fontWeight: isExpanded ? 700 : 600,
          },
        }}
      >
        {header}
      </AccordionSummary>
      <AccordionDetails
        sx={{
          margin: '0 16px 16px 16px',
          h6: { fontSize: theme.typography.subtitle1.fontSize },
        }}
      >
        {children}
      </AccordionDetails>
    </AccordionStyled>
  );
};
